export default __webpack_public_path__ + "static/media/title-genuine.fe6aa497.png";